import * as R from 'ramda'
import { serverUrl, serverPrefixUrl } from '../config'
import axios from 'axios'
import sys from './globalFunction'

const objectToParm = obj => {
    if (!obj || Object.keys(obj).length === 0) {
        return ''
    }
    const array = []
    for (const name in obj) {
        const value = obj[name]
        const parmValue = null ? 'null ' : typeof value === 'string' ? `"${value}"` : `${value}`
        array.push(`${name}:${parmValue}`)
    }
    return `(${array.join(',')})`
}

/**
 * 출력값을 정의해서 호출
 *
 * @param {string} command 호출명령
 * @param {object} parm 호출 argment default null
 * @param {string} resultDef 받아올 결과를 정의 반드시 {}로 감싸야한다.
 * @param {string} type query or mutaion default query
 * @returns {string} graphql 호출 문자열
 */
export const makeSingleQuery = (command, parm = null, resultDef = '', type = 'query') =>
    `${type}{${command}${objectToParm(parm)}${resultDef}}`

const fetch = (
    query,
    errorHandler = sys.alertErrors,
    loadingStartFn = sys.loadingStart,
    loadingEndFn = sys.loadingEnd,
    loadingForceEndFn = sys.loadingForceEnd
) => {
    const makeParameter = () => {
        const method = 'post'
        const url = `${serverUrl}${serverPrefixUrl}/graphql`
        const data = { query }
        const headers = {
            'Content-type': 'application/json',
            Accept: 'application/json',
            'Access-Control-Allow-Credentials' : true
        }
        const accessToken = window.localStorage.getItem('__access_token__')
        const withCredentials = true
        accessToken && (headers['x_access_token'] = accessToken)
        return { method, url, headers, data, withCredentials } //2021.05.31 withCredentials : FLOOR 에서 API 호출 시, 정상동작에 필요
    }

    const defaultCatchHandler = err => {
        const checkStatus = err => R.path(['response', 'status'])(err)
        const dispStatusError = ({ response: { status, statusText } }) =>
            errorHandler([`status:${status}`, statusText])
        const checkMessage = err => R.identity(err.message)
        const dispErrorMessage = () => errorHandler(err.message)
        const checkCustomError = err => err.pass
        const dispError = () => errorHandler(err.toString())
        const checkNetworkErr = err => err.message === 'Network Error'
        const serverNotConnectd = () => errorHandler(['서버에 연결할 수 없습니다.'])
        const run = R.pipe(
            R.cond([
                [checkNetworkErr, serverNotConnectd],
                [checkStatus, dispStatusError],
                [checkMessage, dispErrorMessage],
                [checkCustomError, () => {}],
                [R.T, dispError],
            ]),
            loadingForceEndFn
        )
        run(err)
    }

    const exitFn = () => {
        const err = new Error()
        err.pass = true
        throw err
    }
    const errorHandlerWithExit = R.pipe(errorHandler, exitFn)

    const makeResult = response =>
        R.pipe(
            () => R.path(['data', 'errors'])(response),
            R.cond([
                [R.isNil, () => response.data.data],
                [R.T, errors => errorHandlerWithExit(errors.map(e => e.message))],
            ])
        )()

    const checkAccessToken = R.pipe(
        response => response.headers['x-access-token'],
        R.when(R.identity, token => window.localStorage.setItem('__access_token__', token))
    )

    const run = R.pipe(
        loadingStartFn,
        makeParameter,
        axios,
        R.andThen(R.tap(checkAccessToken)),
        R.andThen(makeResult),
        R.andThen(R.tap(loadingEndFn))
    )
    const catchFn = R.pipe(R.tap(loadingForceEndFn), R.tap(defaultCatchHandler), Promise.reject)

    return run().catch(catchFn)
}

export default fetch
